<template>
  <Loader v-if="loading" />
  <failed-to-load v-else-if="!loading && failed" />
  <div v-else>
    <h2>Gallery</h2>
    <div class="gallery" v-if="gallery.length > 0">
      <div
        class="gallery__submission"
        v-for="submission in gallery"
        :key="submission.id"
      >
        <div class="gallery__submission__artist">
          {{ submission.user.displayName || submission.user.username }}
        </div>
        <router-link
          :to="{
            name: 'art-club-study-submission',
            params: { submission: submission.id },
          }"
        >
          <img :src="submission.thumbnail || submission.url" alt="" />
        </router-link>
      </div>
    </div>
    <div class="gallery-empty" v-if="gallery.length === 0">
      <span class="h3 mb-5">There are no submissions yet</span>
      <app-button
        variant="cta"
        align="center"
        :to="{ name: 'art-club-study-submit' }"
        >Be the first</app-button
      >
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FailedToLoad from '@/components/global/FailedToLoad';
import Loader from '@/components/global/Loader';

export default {
  name: 'art-club-study-gallery',
  data: function() {
    return {
      failed: false,
      loading: false,
    };
  },
  components: { FailedToLoad, Loader },
  async mounted() {
    this.getGalleryHandler();
  },
  methods: {
    ...mapActions('study', ['getGallery']),
    async getGalleryHandler() {
      this.loading = true;
      const res = await this.getGallery(this.$route.params.id);
      if (res && res.status >= 300) {
        this.failed = true;
      }
      this.loading = false;
    },
  },
  computed: {
    ...mapState('study', {
      gallery: state => state.gallery,
      galleryStudyId: state => state.galleryStudyId,
    }),
  },
};
</script>

<style lang="scss">
.gallery {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 0rem;
  position: relative;

  @media screen and (max-width: 767px) {
    margin-left: -1rem;
    margin-right: -1rem;
  }

  @media screen and (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media screen and (min-width: 1366px) {
    grid-template-columns: repeat(6, 1fr);
  }

  &__submission {
    max-width: 100%;
    position: relative;
    display: block;

    &__artist {
      font-size: 0.8rem;
      color: white;
      background: rgba(black, 0.6);
      position: absolute;
      right: 0;
      bottom: 0;
      padding: 0.5rem 1rem;
    }

    img {
      max-width: 100%;
      vertical-align: bottom;
    }
  }
}

.gallery-empty {
  border-radius: 8px;
  background: color('background');
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
}
</style>
